import { Page } from "@shopify/polaris";
import React from "react";
import styled from "styled-components";
import { TransactionsPolaris } from "../../components/admin/transactions/TransactionsPolaris";
import { getPathFromRouter } from "../../helper";

const Container = styled.div`
    margin: -1rem;
    @media (min-width: 640px) {
        margin: -1.5rem;
    }
`;

export const TransactionsPagePolaris = (...props) => {
    const path = React.useMemo(() => {
        return getPathFromRouter(props);
    }, [props]);

    return (
        <Container>
            <Page title="All Transactions" fullWidth>
                <TransactionsPolaris path={path} />
            </Page>
        </Container>
    );
};
